import { Injectable, Injector } from '@angular/core';
import { PointConfigurationDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { PagedResultDto } from '@common-modules/shared/model/paged-result.dto';
import { GridODataService } from '@common-modules/shared/odata/grid-odata.service';

@Injectable({
  providedIn: 'root',
})
export class PointConfigurationsService extends GridODataService<PointConfigurationDto> {
  constructor(injector: Injector) {
    super(injector, '/api/telemetry/point');
  }

  protected mapResponse(
    response: PagedResultDto<PointConfigurationDto>,
  ): PagedResultDto<PointConfigurationDto> {
    return response;
  }
}
